module.exports = __webpack_public_path__ + "img/status3.4de27bec.svg";